module.exports = __webpack_public_path__ + "static/media/neitorLogo.6d58786c.jpeg";